import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ShippingAccountComponent } from './component';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { getNameFromOrdinal, ACCOUNT } from '../../../../../enums/bill-to-party';
import { messages } from '../messages';

export const ShippingAccount = {
  id: 'shippingAccount',
  displayName: <FormattedMessage {...messages.shippingAccount} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'SellerProviderId',
  defaultMetaValue: { value: ACCOUNT },
  expectsArgumentAsArray: true,
  render: (criteriaInformations) => <ShippingAccountComponent criteriaInformations={criteriaInformations} />,

  mapV2SavedFilterToV3Applied: (value, column) => {
    if (column === 'BillToParty') {
      return {
        criterionMeta: {
          value: getNameFromOrdinal(value),
        },
      };
    }
    return {
      criterionArgumentValue: value,
      criterionMeta: {
        value: 'Account',
      },
    };
  },
};
